<div class="bds-flexbox bds-flex-row bds-gap-24">
    <div class="content-wrapper bds-grow-1">
        <ng-content select=".content"></ng-content>
    </div>
    <div class="context-wrapper">
        <div class="context-layout">
            <ng-content select=".context"></ng-content>
        </div>
    </div>
</div>